import styled from "styled-components";
import fipayFonts from "../../../theme/index";
import { colors } from "../../../theme/color";

export const FeaturesContainer = styled.div`
  width: 100%;
  height: 960px;
  padding-top: 50px;
  padding-bottom: 50px;
  overflow: hidden;
  @media screen and (max-width: 2560px) {
    height: 1080px;
  }

  @media screen and (max-width: 1440px) {
    width: 100%;
    height: 940px;
  }
  @media screen and (max-width: 1024px) {
    width: 100%;
    height: 860px;
  }
  @media screen and (max-width: 768px) {
    width: 768px;
    height: 834px;
  }
  @media screen and (max-width: 430px) {
    width: 100%;
    height: 744px;
  }
  @media screen and (max-width: 375px) {
    width: 375px;
    height: 754px;
  }
  @media screen and (max-width: 320px) {
    width: 320px;
    height: 754px;
  }
`;

export const CarouselHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
  padding-bottom: 50px;
  margin-top: 50px;
  overflow-x: scroll;

  @media screen and (max-width: 2560px) {
    height: 850px;
    align-items: flex-start;
    --limit: 0%;
  }
  @media screen and (max-width: 1920px) {
    height: 850px;
    align-items: flex-start;
    --limit: -30%;
  }
  @media screen and (max-width: 1440px) {
    height: 750px;
    padding-left: 550px;
    align-items: flex-start;
    --limit: -40%;
  }
  @media screen and (max-width: 1024px) {
    height: 750px;
    padding: 0 50px 0 0px;
    justify-content: center;
    align-items: flex-start;
    --limit: -80%;
  }
  @media screen and (max-width: 768px) {
    height: 750px;
    padding: 0 50px 0 50px;
    justify-content: center;
    align-items: flex-start;
    --limit: -170%;
  }
  @media screen and (max-width: 430px) {
    height: 700px;
    align-items: flex-start;
    padding: 0px 0px 0px 300px;
    margin-left: 10px;
    --limit: -200%;
  }
  @media screen and (max-width: 375px) {
    height: 700px;
    align-items: flex-start;
    margin-left: 10px;
    --limit: -200%;
  }
  @media screen and (max-width: 320px) {
    align-items: flex-start;
  }
`;

export const TitleText = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.display2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.NAVYBLUE};

  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    text-align: center;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    text-align: center;
  }
`;

export const CarouselHolderLarge = styled.div`
  height: 800px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 2560px) {
    width: 100%;
  }
  @media screen and (max-width: 1440px) {
    width: 100%;
    margin-top: 40px;
  }

  @media screen and (max-width: 1024px) {
  }
  @media screen and (max-width: 768px) {
    display: none;
  }

  @media screen and (max-width: 430px) {
    display: none;
  }
  @media screen and (max-width: 375px) {
    display: none;
  }
`;

export const CarouselHolderSmall = styled.div`
  width: 529px;
  height: 1024px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 2560px) {
    display: none;
  }
  @media screen and (max-width: 1440px) {
    display: none;
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }
  @media screen and (max-width: 768px) {
    display: flex;
    width: 100%;
  }
`;
